<template>
  <div class="onboarding-dashboard">
    <div class="onboarding-dashboard__infos">
      <div class="onboarding-dashboard__about-model">
        <h1 class="onboarding-dashboard__title">
          {{ dashboardModels.title }}
        </h1>
        <p class="onboarding-dashboard__description">
          {{ dashboardModels.description }}
        </p>
      </div>
      <div>
        <h1 class="onboarding-dashboard__indicated-title">
          {{ $t('components.Onboarding.label.title.indicatedForMessage') }}
        </h1>
        <div class="onboarding-dashboard__case-chips">
          <div
            v-for="item in dashboardModels.useCases"
            :key="item"
            class="onboarding-dashboard__chips"
          >
            <DsChip :title="item" />
          </div>
        </div>
      </div>
    </div>
    <OnboardingImageTemplate :dashboard-image="dashboardModels.img" />
  </div>
</template>

<script>
import { DsChip } from '@ds/components';
import OnboardingImageTemplate from '@/components/onboarding/OnboardingImageTemplate';

export default {
  name: 'OnboardingDashboardInfos',
  components: {
    DsChip,
    OnboardingImageTemplate,
  },
  props: {
    dashboardModels: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-dashboard {
    display: flex;
    background: var(--ds-color-neutral);
    border-radius: var(--ds-border-radius-md);
    border: var(--ds-border-width-hairline) solid var(--ds-color-silver);
    width: 893px;
    height: 292px;
    padding: var(--ds-spacing-stack-sm);

    &__infos {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 465px;
    }

    &__title {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-md);
      line-height: var(--ds-font-line-height-slim);
    }

    &__description {
      margin-top: var(--ds-spacing-stack-nano);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-sm);
      line-height: var(--ds-font-line-height-loose);
    }

    &__about-model {
      width: 465px;
      height: 100px;
    }

    &__indicated-title {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
      margin-bottom: var(--ds-spacing-stack-nano);
    }

    &__case-chips {
      display: flex;
      flex-wrap: wrap;
    }

    &__chips {
      display: inline;
      margin-right: var(--ds-spacing-inline-nano);
      margin-bottom: var(--ds-spacing-inline-nano);
    }
  }

  ::v-deep .ds-chip {
    cursor: default;
  }
</style>
